import styled from "styled-components";
import { TextColorNames } from "@smartsuite/types";

export {
  StyledFieldLabel,
  StyledTextInput,
} from "../BranchesBlockSection/styles";
// Same 40px accent circle as the block panel's header icon.
export { StyledBlockIcon as StyledBranchHeaderIconCircle } from "../BranchesBlockSection/styles";

/** Panel-local error red (matches Figma; deliberately not the design
 * system's $error #FF5757). Shared with the name input's error border. */
export const BRANCH_NAME_ERROR_COLOR = "#e5484d";

export const StyledBranchHeaderRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
`;

export const StyledModeRow = styled.div`
  margin: 35px 0 15px 0;
  border-bottom: 1px solid #e9e9e9;
  padding-bottom: 10px;

  .short-select {
    color: var(--typo-primary, ${TextColorNames.primary});
  }

  .select-placeholder:not(.is-active) .select-placeholder__arrow {
    color: var(--typo-primary, ${TextColorNames.primary});
  }
`;

export const StyledInlineError = styled.p`
  margin: 4px 0 0;
  font-size: 12px;
  line-height: 16px;
  color: ${BRANCH_NAME_ERROR_COLOR};
`;
